import SvgIcon from "@mui/material/SvgIcon";

export const ReferralsProgramIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M14.5 8.5h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1zm-5-6v5h5v-5h-5zM14.5 22.5h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1zm-5-6v5h5v-5h-5zM6.5 22.5h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1zm-5-6v5h5v-5h-5zM22.5 22.5h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1zm-5-6v5h5v-5h-5zM20.5 15h-1v-2.5h-15V15h-1v-3a.5.5 0 01.5-.5h16a.5.5 0 01.5.5v3z"></path>
      <path fill="#fff" d="M12.5 9h-1v6h1V9z"></path>
    </svg>
  </SvgIcon>
);
